import React from "react";
import './Home.css';
import Image0 from '../../../assets/img/Service-list/home-image-00.png'
import Image1 from '../../../assets/img/Service-list/home-image-01.png'
import flag from '../../../assets/img/Service-list/flag.png'
import AlternatingContainer from "../../Constant/AlternatingContainer/AlternatingContainer";
import AlternatingSection from "../../Constant/AlternatingSection/AlternatingSection";

function Home() {
    const alternatingData = [
        {
            leftTitle: "Trusted & Reliable",
            leftText:
                "With a proven track record and a commitment to transparency and integrity in the online gaming business, Anjouan Licensing Services Inc. has earned the trust of gaming operators worldwide. Applicants benefit from our deep industry knowledge, strong regulatory framework, and efficient processing of applications.",
            rightTitle: "The Simplicity of a Modern Application Process",
            rightText:
                "At Anjouan Licensing Services Inc., we pride ourselves on offering the most advanced application process of any internet gaming licensor. Our state-of-the-art platform ensures a seamless experience, minimizing delays and maximizing efficiency, so you can get your gaming operations up and running quickly.",
        }
    ];

    const data = [
        {
            title: "B2C Licensing",
            text:
                `
                    Having an Internet Gaming License from the Autonomous Island of Anjouan for B2C operations demonstrates that an operator has met the strict compliance and fair play requirements which will enable the offering of games to players in jurisdictions all over the world.
                    <br/>
                    Additionally, it will allow you to operate your business with peace of mind, knowing that you’re in compliance with all applicable laws and regulations.
                    <br/>
                    <strong>Strategic Advantage: </strong>
                    Being licensed by Anjouan demonstrates your commitment to operating within a legitimate and structured regulatory environment. This enhances your reputation with clients and partners, building trust and fostering long-term business relationships.
                    <strong>Global Reach: </strong>
                    We have licensed numerous new and existing businesses empowering them to establish and grow their gaming operations, providing them with the competitive edge needed in a dynamic industry.
                `,
            image: Image0,
            alt: "Image 1",
        },
        {
            title: "B2B Licensing",
            text:
                `
                    Having an Internet Gaming License from the Autonomous Island of Anjouan for B2B operations demonstrates that a critical supplier has met the strict compliance and testing requirements ensuring fair play.
                    <br/>
                    This ensures you can operate your business with peace of mind, knowing that you’re in compliance with all applicable laws and regulations
                    <br/>
                    <strong>Strategic Advantage: </strong>
                    Obtaining an Anjouan license as a B2B supplier offers several strategic advantages that can significantly enhance your business operations and reputation.                    
                `,
            image: Image1,
            alt: "Image 1",
        }
    ]

    return (
        <section className='section'>

            <div className='container'>
                <h1 className='section-title'>
                    Your Gateway to World-Class Gaming Licensing
                </h1>
                <p>
                    Anjouan Licensing Services Inc. is the exclusive and official authority for gaming licenses on the
                    autonomous island of Anjouan. With over 26 years of experience in the industry, we are proud to be
                    the sole authorized license administrator and the official representatives of the Anjouan Offshore
                    Financial Authority and the Anjouan Gaming Board.
                </p>
            </div>

            <AlternatingContainer sections={alternatingData}/>

            <div className="stacked-data-container container">
                <article className="stacked-data-item">
                    <h2 className="stacked-data-title">
                        Global Credibility and Trust
                    </h2>
                    <p className="stacked-data-description">
                        An Anjouan Internet Gaming License is issued by a highly respected jurisdiction, providing your
                        business with immediate credibility and trustworthiness. In the competitive world of online
                        gaming, where reputation is everything, having a license from Anjouan signals to players,
                        partners, and investors that you operate under stringent regulatory standards. This credibility
                        can significantly enhance your brand’s reputation, attracting more customers and business
                        opportunities.
                    </p>
                </article>
                <article className="stacked-data-item">
                    <h2 className="stacked-data-title">
                        Access to a Modern and Efficient Regulatory Framework
                    </h2>
                    <p className="stacked-data-description">
                        Anjouan offers the most modern and efficient application process of any internet gaming
                        licensor. This streamlined process not only saves you time and resources but also ensures that
                        you can get your operations up and running quickly. A license from Anjouan allows you to focus
                        on growing your business rather than being bogged down by cumbersome regulatory hurdles, giving
                        you a competitive edge in a fast-paced industry.
                    </p>
                </article>
                <article className="stacked-data-item">
                    <h2 className="stacked-data-title">
                        Legal Security and Long-Term Stability
                    </h2>
                    <p className="stacked-data-description">
                        Operating under an Anjouan Internet Gaming License provides you with robust legal protection and
                        long-term stability. The regulatory environment in Anjouan is designed to be both supportive and
                        adaptive, ensuring that your business remains compliant with evolving laws and regulations. This
                        security reduces the risk of legal challenges and disruptions, allowing you to operate with
                        confidence and focus on scaling your business in the internet gaming market.
                    </p>
                </article>
            </div>

            <AlternatingSection sections={data}/>

            <section className='page-banner-section dark-bg container'>
                <div className='page-banner-container container'>
                    <h1 className='page-banner-text white medium-size'>
                        The AOFA has consistently demonstrated its commitment to maintaining high regulatory standards
                        and ensuring compliance with international best practices.
                    </h1>
                    <p className='page-banner-text gray'>
                        Its stringent regulations have helped mitigate risks associated with money laundering, terrorist
                        financing, and other illicit activities, promoting a clean and reputable offshore financial
                        sector.
                    </p>
                    <div className='page-banner-border'></div>
                    <p className='page-banner-text white normal-size'>
                        Anjouan Licensing Services Inc, continues to promote and improve regulatory excellence amongst
                        all licensees.
                    </p>
                    <img src={flag} alt='flag' className='page-banner-flag'/>
                </div>
            </section>

            <div className="key-container section container">
                <h1 className="key-title section-title">
                    Anjouan Gaming License
                </h1>
                <h2 className="key-subtitle ">
                    Your Key to Success in the Online Gambling Industry
                </h2>

                <div className="key-content">
                    <p className="key-text">
                        The online gaming industry is a rapidly growing market, with billions of dollars in revenue
                        generated each year. If you’re looking to get involved in this lucrative industry, you need to
                        make sure you have the right license.
                    </p>
                    <p className="key-text">
                        That’s where the Anjouan Gaming License comes in.
                    </p>
                    <p className="key-text">
                        The Anjouan Gaming License is a recognized and respected license that will give you the
                        credibility you need to succeed in the online gaming industry.
                    </p>

                    <section className="key-section">
                        <h3 className="key-section-title">
                            With an Anjouan Gaming License, you’ll be able to:
                        </h3>
                        <ul className="key-list">
                            <li className="key-list-item">
                                Offer your games to players in jurisdictions all over the world
                            </li>
                            <li className="key-list-item">
                                Operate your business with peace of mind, knowing that you’re in compliance with all
                                applicable laws and regulations
                            </li>
                            <li className="key-list-item">
                                Gain access to a network of experienced and knowledgeable professionals who can help you
                                grow your business
                            </li>
                        </ul>
                        <p className="key-text">
                            If you’re serious about success in the online gaming industry, then you need to get an
                            Anjouan Gaming License. Contact us today to learn more about how we can help you get
                            started.
                        </p>
                    </section>

                    <section className="key-section">
                        <h3 className="key-section-title">
                            Benefits:
                        </h3>
                        <ul className="key-list">
                            <li className="key-list-item">
                                <span className="key-highlight">Legality:</span> The Anjouan Gaming License is
                                recognized and respected by governments all over the world, giving you the peace of mind
                                of knowing that you’re operating your business in a legal and compliant manner.
                            </li>
                            <li className="key-list-item">
                                <span className="key-highlight">Convenience:</span> The application process for an
                                Anjouan Gaming License is quick and easy, and you can even apply online.
                            </li>
                            <li className="key-list-item">
                                <span className="key-highlight">Cost-effectiveness:</span> The cost of an Anjouan Gaming License is very reasonable, making it a cost-effective option for businesses of all sizes.
                            </li>
                            <li className="key-list-item">
                                <span className="key-highlight">Flexibility:</span> The Anjouan Gaming License is very flexible, allowing you to offer a wide variety of games and services to your players.
                            </li>
                        </ul>
                        <p className="key-text">
                            If you’re looking for a reputable and affordable way to obtain a gaming license, then the Anjouan Gaming License is the perfect option for you.
                        </p>
                    </section>
                </div>
            </div>

        </section>
    )
}

export default Home;